import { Box, Grid } from "@mui/material";
import { useTeamConfig } from "src/components/reusable/components/TeamConfigProvider";
import { useCssMediaQuery } from "src/components/base/hooks/useCssMediaQuery";
import { TPassGroupCardProps } from "src/shared/types/pass-group-card-props";

export interface PassGroupCardContainerProps {
  cardProps: TPassGroupCardProps;
}

export function PassGroupCardContainer(props: PassGroupCardContainerProps) {
  const { md: mdUp } = useCssMediaQuery("up");
  const { TEAM_GLOBAL_SETTINGS } = useTeamConfig();
  const cardCount = TEAM_GLOBAL_SETTINGS?.PASS_GROUP_CARDS?.length || 0;
  const cardComponents = TEAM_GLOBAL_SETTINGS?.PASS_GROUP_CARDS || [];

  return (
    <Box>
      <Grid
        container
        spacing={3}
        justifyContent={mdUp ? "center" : "flex-start"}
      >
        {cardComponents?.map((CardComponent, idx) => {
          return (
            <Grid
              item
              key={idx}
              xs={12}
              sm={cardCount <= 1 ? 12 : 6}
              lg={cardCount <= 1 ? 12 : 4}
            >
              <CardComponent {...props?.cardProps} />
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}
